import { Component, OnInit, Input, Optional, Self, ElementRef } from '@angular/core';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { ControlValueAccessor, UntypedFormGroup, NgControl, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { FocusMonitor } from '@angular/cdk/a11y';
import { List } from 'linqts';
import { Point } from '../../lottoloca-commom/lottery-modex';

@Component({
  selector: 'app-coordinates',
  templateUrl: './coordinates.component.html',
  styleUrls: ['./coordinates.component.css'],
  providers: [
    
    { provide: MatFormFieldControl, useExisting: CoordinatesComponent },
 
  ],
  host: {
    '[class.floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
 })
export class CoordinatesComponent implements MatFormFieldControl<Point[]>, ControlValueAccessor, OnInit {

  static nextId = 0;
  parts: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  //ngControl = null;
  errorState = false;
  controlType = 'coordinates';
  id = `coordinates-${CoordinatesComponent.nextId++}`;
  describedBy = '';
  _isReady: boolean = false;
_items:UntypedFormArray;

  private onChange: (value: Point[]) => void;
  private _value: Point[] = [];


  constructor(@Optional() @Self() public ngControl: NgControl,
    fb: UntypedFormBuilder,
    private fm: FocusMonitor,
    private elRef: ElementRef<HTMLElement>,
    private formBuilder: UntypedFormBuilder) {

    // Setting the value accessor directly (instead of using
    // the providers) to avoid running into a circular import.
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; }

    this.parts = fb.group({
      textValue: ''
    });

    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });
  }



  public changeDate() {

    this.onChange(this.value);
  }

  writeValue(obj: Point[]): void {

    this.value = obj;

    // this.value.forEach(x=>
    //   {
    //     x.X = parseFloat(x.X.toString());
    //     x.Y = parseFloat(x.Y.toString());
    //   });
    this.updateGui();
  }
  registerOnChange(onChange: (value: Point[]) => void): void {
    this.onChange = onChange;
  }
  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if (isDisabled) {
      this.parts.get("textValue").disable();
    }
    else {
      this.parts.get("textValue").enable();
    }
  }


  get empty() {
    const { value: { textValue } } = this.parts;

    return !textValue;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }

  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): Point[] | null {


    return this._value;

  }

  set value(value: Point[] | null) {

    if (value == null) {
      this._value = [];
    }
    else {

      this._value = value;
    }

    this.updateGui();

    this.stateChanges.next();
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {
    if ((event.target as Element).tagName.toLowerCase() != 'input') {
      this.elRef.nativeElement.querySelector('input')!.focus();
    }
  }



  //******************************* */

  public _indexes: any[] = [];

  public updateGui(): any {

    let items:Array<UntypedFormGroup> = [];

    this.value.forEach(x=>
      {
        items.push(this.createItem(x.X,x.Y))
      });

    this.orderForm = this.formBuilder.group({
         items: this.formBuilder.array(items)
    });

    this._items = this.orderForm.get("items") as UntypedFormArray;

    this.orderForm.valueChanges
    .subscribe(()=>
    {
      this.propagateChanges();
    });
  }

  public showValue() {
 
  }

  public onChangeCoordinate(X: number, Y: number, value: any) {


  }

  public addPoint() {

    this.addItem();
  }

  public addItem(): void {

    let items = this.orderForm.get('items') as UntypedFormArray;

    items.push(this.createItem(0,0));

  }

  public propagateChanges() {
    
    let items = this.orderForm.get('items') as UntypedFormArray;

    this._value = items.value;

    if (this.onChange != null) {

       this.onChange(this.value)
    }
  }

  public showValues() {

  }

  public createItem(x:number,y:number): UntypedFormGroup {

    // let  name =  this.orderForm.get('newDescription').value;

    // x = parseFloat(x.toString());
    // y = parseFloat(y.toString());

    return this.formBuilder.group({
      X: x,
      Y: y
    });

  }

  orderForm: UntypedFormGroup;

  ngOnInit() {
    this.updateGui()
  }

  
  public remove(index:number) {

    this._items = this.orderForm.get("items") as UntypedFormArray;

    this._items.removeAt(index);

  }

}
